<template>
  <q-layout view="hHh lpR fFf">
    <q-page-container>
      <q-page class="flex flex-center" style="min-height: 100vh; background: linear-gradient(135deg, #4688f5 0%, #ffffffff 100%);">
        <div class="registration-container q-pa-lg">
          <!-- Card de Sucesso -->
          <q-card v-if="registrar.quartaEtapa" class="success-card">
            <q-card-section class="text-center q-pt-xl">
              <q-icon name="check_circle" size="80px" color="positive" />
              <h5 class="text-h5 text-weight-medium q-mt-md q-mb-none">Cadastro Realizado!</h5>
            </q-card-section>

            <q-card-section class="text-center" v-if="hasVideo">
              <youtube
                ref="youtube"
                class="video-youtube"
                :width="560"
                :height="315"
                style="width: 100%; max-width: 560px; height: 315px; border-radius: 8px;"
                :src="videoId"
                :vars="playerVars"
              />
            </q-card-section>

            <q-card-section class="q-px-xl">
              <p class="text-body1 q-mb-md">
                <strong>{{ registro.nome }}</strong>, enviamos um e-mail para
                <strong>{{ registro.email }}</strong> contendo suas credenciais de acesso.
              </p>
              
              <q-banner rounded class="bg-blue-1 q-mb-md">
                <template v-slot:avatar>
                  <q-icon name="info" color="blue-7" />
                </template>
                <div class="text-body2">
                  Clique no link de ativação enviado no seu e-mail para completar o cadastro e ter acesso ao melhor sistema de gestão financeira.
                </div>
              </q-banner>

              <p class="text-body2 text-grey-7">Abraços, Equipe DouraSoft do Brasil.</p>

              <div class="row q-gutter-sm q-mt-md">
                <q-btn
                  label="Saiba Mais"
                  color="blue-7"
                  class="col"
                  @click="gotoPortal()"
                />
                <q-btn
                  outline
                  label="Fazer Login"
                  color="blue-7"
                  class="col"
                  to="/login"
                />
              </div>
            </q-card-section>
          </q-card>

          <!-- Stepper de Registro -->
          <q-card v-else class="registration-card">
            <q-card-section class="text-center q-pt-xl q-pb-lg">
              <img src="@/assets/douranovo.png" alt="DouraSoft Logo" style="width: 180px; height: auto;" />
            </q-card-section>

            <q-stepper
              v-model="step"
              ref="stepper"
              color="blue-7"
              animated
              flat
              class="custom-stepper"
            >
              <!-- Etapa 1: Dados Pessoais -->
              <q-step
                :name="1"
                title="Dados Pessoais"
                icon="person"
                :done="step > 1"
                :header-nav="step > 1"
              >
                <div class="q-gutter-md q-px-md">
                  <q-input
                    type="email"
                    v-model="registro.email"
                    label="E-mail"
                    @blur="userCheckEmail(registro)"
                    :error="errors.email ? true : false || status"
                    :error-message="errors.email ? errors.email[0] : status ? 'Email já está sendo utilizado' : ''"
                    bottom-slots
                  >
                    <template v-slot:append v-if="!status && registro.email && registro.email.length > 0">
                      <q-icon
                        :name="!warning ? 'check_circle' : 'warning'"
                        :color="!warning ? 'positive' : 'negative'"
                      />
                    </template>
                  </q-input>

                  <q-input
                    v-model="registro.nome"
                    label="Nome Completo"
                    :error="errors.nome ? true : false"
                    :error-message="errors.nome ? errors.nome[0] : ''"
                    bottom-slots
                  />

                  <q-input
                    :disable="codigoValido"
                    v-model="registro.celular"
                    label="WhatsApp"
                    mask="(##) #####-####"
                    :hint="!recebeuPrimeiroCodigo ? 'Você receberá um código de ativação via WhatsApp' : ''"
                    :error="errors.celular ? true : false"
                    :error-message="errors.celular ? errors.celular[0] : ''"
                    bottom-slots
                  >
                    <template v-slot:append v-if="codigoValido">
                      <q-icon name="verified" color="positive" />
                    </template>
                  </q-input>

                  <div v-if="recebeuPrimeiroCodigo && !codigoValido">
                    <q-input
                      v-model="codigo"
                      label="Código de Verificação"
                      :mask="mascaraCodigo"
                      :error="!!errors.codigo"
                      :error-message="erroCodigo"
                      hint="Digite o código recebido no WhatsApp"
                      bottom-slots
                    />

                    <div class="text-caption text-grey-7 q-mt-sm">
                      Não recebeu o código?
                      <span
                        v-if="!loadingReceberCodigo && tempoProximoCodigo === 0"
                        class="text-blue-7 cursor-pointer"
                        @click="receberCodigo()"
                      >
                        Enviar novamente
                      </span>
                      <span v-else>
                        Aguarde {{ tempoProximoCodigo }}s para reenviar
                      </span>
                    </div>
                  </div>
                </div>
              </q-step>

              <!-- Etapa 2: Dados da Empresa -->
              <q-step
                :name="2"
                title="Dados da Empresa"
                icon="business"
                :done="step > 2"
                :header-nav="step > 1"
              >
                <div class="q-gutter-md q-px-md">
                  <q-input
                    v-model="registro.cnpj"
                    label="CNPJ"
                    mask="##.###.###/####-##"
                    :error="errors.cnpj ? true : false"
                    :error-message="errors.cnpj ? errors.cnpj[0] : ''"
                    bottom-slots
                  />
                </div>
              </q-step>

              <!-- Etapa 3: Endereço -->
              <q-step
                :name="3"
                title="Endereço"
                icon="location_on"
                :header-nav="step > 2"
              >
                <div class="q-gutter-md q-px-md">
                  <q-input
                    v-model="registro.razao"
                    label="Razão Social"
                    :error="errors.razao ? true : false"
                    :error-message="errors.razao ? errors.razao[0] : ''"
                    bottom-slots
                  />

                  <q-input
                    v-model="registro.fantasia"
                    label="Nome Fantasia"
                    :error="errors.fantasia ? true : false"
                    :error-message="errors.fantasia ? errors.fantasia[0] : ''"
                    bottom-slots
                  />

                  <div class="row q-col-gutter-md">
                    <div class="col-12 col-sm-6">
                      <q-input
                        v-model="registro.cep"
                        label="CEP"
                        mask="#####-###"
                        :error="errors.cep ? true : false"
                        :error-message="errors.cep ? errors.cep[0] : ''"
                        bottom-slots
                      >
                        <template v-slot:append v-if="registro.cep && registro.cep.length > 0">
                          <q-btn
                            round
                            dense
                            flat
                            icon="search"
                            color="blue-7"
                            :loading="fetchCEP.buscandoCEP"
                            @click="consultaCEP(registro.cep)"
                          >
                            <q-tooltip>Buscar CEP</q-tooltip>
                          </q-btn>
                        </template>
                      </q-input>
                    </div>

                    <div class="col-12 col-sm-6">
                      <q-input
                        v-model="registro.cidade"
                        label="Cidade"
                        :error="errors.cidade ? true : false"
                        :error-message="errors.cidade ? errors.cidade[0] : ''"
                        bottom-slots
                      />
                    </div>

                    <div class="col-12 col-sm-6">
                      <q-input
                        v-model="registro.estado"
                        label="Estado"
                        :error="errors.estado ? true : false"
                        :error-message="errors.estado ? errors.estado[0] : ''"
                        bottom-slots
                      />
                    </div>

                    <div class="col-12 col-sm-6">
                      <q-input
                        v-model="registro.bairro"
                        label="Bairro"
                        :error="errors.bairro ? true : false"
                        :error-message="errors.bairro ? errors.bairro[0] : ''"
                        bottom-slots
                      />
                    </div>

                    <div class="col-12">
                      <q-input
                        v-model="registro.endereco"
                        label="Endereço"
                        :error="errors.endereco ? true : false"
                        :error-message="errors.endereco ? errors.endereco[0] : ''"
                        bottom-slots
                      />
                    </div>

                    <div class="col-12 col-sm-6">
                      <q-input
                        v-model="registro.numero"
                        label="Número"
                        id="numero"
                        :error="errors.numero ? true : false"
                        :error-message="errors.numero ? errors.numero[0] : ''"
                        bottom-slots
                      />
                    </div>

                    <div class="col-12 col-sm-6">
                      <q-input
                        v-model="registro.complemento"
                        label="Complemento"
                        :error="errors.complemento ? true : false"
                        :error-message="errors.complemento ? errors.complemento[0] : ''"
                        bottom-slots
                      />
                    </div>
                  </div>

                  <q-separator class="q-my-md" />

                  <div class="q-px-md">
                    <q-checkbox
                      v-model="registro.acceptTerms"
                      color="blue-7"
                      :error="errors.acceptTerms ? true : false"
                    >
                      <span class="text-body2">
                        Concordo com os
                        <a
                          href="https://dourasoft.com.br/termos-de-uso/"
                          target="_blank"
                          class="text-blue-7"
                          style="text-decoration: none;"
                        >
                          Termos de Uso
                        </a>
                      </span>
                    </q-checkbox>
                    <div v-if="errors.acceptTerms" class="text-negative text-caption q-ml-md">
                      {{ errors.acceptTerms[0] }}
                    </div>
                  </div>
                </div>
              </q-step>

              <template v-slot:navigation>
                <q-stepper-navigation class="q-px-md q-pb-md">
                  <div class="row q-gutter-sm">
                    <q-btn
                      v-if="step > 1"
                      flat
                      color="blue-7"
                      label="Voltar"
                      @click="$refs.stepper.previous()"
                      class="col"
                    />
                    
                    <q-btn
                      v-if="step === 1 && !codigoValido"
                      color="blue-7"
                      :label="!recebeuPrimeiroCodigo ? 'Receber Código' : 'Verificar Código'"
                      :loading="loadingVerificarCodigo"
                      :disable="recebeuPrimeiroCodigo && (!codigoCompleto || codigo === ultimoCodigo)"
                      @click="verificarCodigo()"
                      class="col"
                    />

                    <q-btn
                      v-if="step === 1 && codigoValido"
                      color="blue-7"
                      label="Continuar"
                      @click="$refs.stepper.next()"
                      class="col"
                    />

                    <q-btn
                      v-if="step === 2"
                      color="blue-7"
                      label="Continuar"
                      :loading="fetchCNPJ.buscandoCNPJ"
                      :disable="!registro.cnpj || registro.cnpj.length === 0"
                      @click="consultaCNPJ()"
                      class="col"
                    />

                    <q-btn
                      v-if="step === 3"
                      color="blue-7"
                      label="Finalizar Cadastro"
                      :loading="registrar.saveRegistro"
                      @click="registrarse()"
                      class="col"
                    />
                  </div>
                </q-stepper-navigation>
              </template>
            </q-stepper>

            <q-separator />

            <q-card-section class="text-center q-py-md">
              <p class="text-body2 text-grey-7 q-ma-none">
                Já possui cadastro?
                <router-link to="/login" class="text-blue-7" style="text-decoration: none; font-weight: 500;">
                  Fazer Login
                </router-link>
              </p>
            </q-card-section>
          </q-card>
        </div>
      </q-page>
    </q-page-container>
  </q-layout>
</template>

<script>
import axios from 'axios';
import { Notify, createMetaMixin } from 'quasar';
import { bus } from '@/utils/bus';
import { mapGetters } from "vuex";
import YouTube from "vue3-youtube";

/**
 * `vue-youtube` stopped at Vue 2. `vue3-youtube` exports the component directly, with
 * no plugin and no `getIdFromUrl`, hence the local copy of that id extraction.
 * <youtube> itself is registered globally in main.js.
 */
function getIdFromUrl(url) {
  if (!url) return "";
  const m = String(url).match(/(?:youtube\.com\/(?:watch\?v=|embed\/|v\/)|youtu\.be\/)([\w-]{11})/);
  return m ? m[1] : "";
}


export default {
  name: 'Registro',
  mixins: [createMetaMixin({ title: 'DSB | Registro' })],
  data() {
    return {
      warning: false,
      status: false,
      step: 1,
      recebeuPrimeiroCodigo: false,
      fecharAvisoEnvio: null,
      // Uma fonte só para o tamanho do código: a máscara e a validação
      // estarem em lugares diferentes foi o que travou o cadastro quando o
      // backend passou de 4 para 6 dígitos.
      TAMANHO_CODIGO: 6,
      // Aceita o código curto enquanto o backend antigo ainda estiver no ar:
      // sem isso, front e back teriam de subir no mesmo instante, e qualquer
      // ordem de deploy deixaria o cadastro impossível de concluir.
      TAMANHO_CODIGO_MINIMO: 4,
      loadingReceberCodigo: false,
      loadingVerificarCodigo: false,
      codigo: null,
      tempoProximoCodigo: 0,
      ultimoCodigo: null,
      codigoValido: false,
      hasVideo: false,
      playerVars: {
        autoplay: 0,
        controls: 1,
      },
      videoId: ''
    };
  },
  watch: {
    passosRegistro(value) {
      if (value === 1) {
        this.step = 1;
      } else if (value === 2) {
        this.step = 2;
      }
    },
    videoRegistro: {
      handler(value) {
        if (value.link !== null) {
          this.videoId = getIdFromUrl(value.link);
          this.hasVideo = true;
        }
      },
      deep: true
    }
  },
  computed: {
    ...mapGetters([
      'videoRegistro',
      'registrar',
      'passosRegistro',
      'registro',
      'fetchCNPJ',
      'fetchCEP',
    ]),
    mascaraCodigo() {
      return '#'.repeat(this.TAMANHO_CODIGO);
    },
    // confirmar-codigo-celular manda errors.codigo como texto; a validação, como lista
    erroCodigo() {
      const erro = this.errors && this.errors.codigo;
      if (!erro) return '';
      return Array.isArray(erro) ? erro[0] : erro;
    },
    codigoCompleto() {
      const tamanho = (this.codigo || '').length;

      return tamanho >= this.TAMANHO_CODIGO_MINIMO && tamanho <= this.TAMANHO_CODIGO;
    },
    errors() {
      return this.registrar.errors;
    },
  },
  methods: {
    consultaCNPJ() {
      this.$store.commit('registrar', {
        ...this.registrar,
        errors: {},
      });

      let dados = {
        cnpj: this.registro.cnpj,
        url: '/empresas/cnpj/',
        onSuccess: () => this.$refs.stepper.next(),
      };
      this.$store.dispatch('fetchCNPJ', dados);
    },
    consultaCEP() {
      this.$store.dispatch('fetchCEP', this.registro.cep);
      document.getElementById('numero').focus();
    },
    registrarse() {
      this.$store.dispatch('registrar', this.registro);
    },
    gotoPortal() {
      window.open('https://dourasoft.com.br/portal', '_blank');
    },
    userCheckEmail(value) {
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value.email)) {
        this.warning = true;
        this.status = false;
        return;
      }
      axios
        .post(
          '/users/registrar?checkemail=' + value.email,
          {},
          {
            headers: {
              Accept: 'application/json',
              'Content-Type': 'application/json',
            },
          }
        )
        .then(res => {
          this.warning = false;
          this.status = !res.data.success;
        })
        .catch(() => {
          Notify.create({
            message: 'Não foi possível verificar email !',
            color: 'red',
            position: 'top-right',
          });
        });
    },
    verificarCodigo() {
      this.loadingVerificarCodigo = true;

      if (!this.recebeuPrimeiroCodigo) {
        this.receberCodigo();
        return;
      }

      const data = {
        uuid: this.registro.uuid,
        codigo: this.codigo,
      };

      this.$store.commit('registrar', {
        ...this.registrar,
        errors: {},
      });

      axios
        .post('/users/confirmar-codigo-celular', data, {
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
          },
        })
        .then(res => {
          this.loadingVerificarCodigo = false;

          if (!res.data.success) {
            this.ultimoCodigo = data.codigo;

            this.$q.notify({
              message: res.data.message,
              color: 'orange',
              position: 'top-right',
            });

            this.$store.commit('registrar', {
              ...this.registrar,
              errors: res.data.errors || {},
            });
            return;
          }

          this.codigoValido = true;
          this.fecharAvisoDeEnvio();
          this.$refs.stepper.next();
        })
        .catch(() => {
          this.loadingVerificarCodigo = false;
          this.ultimoCodigo = data.codigo;

          this.$q.notify({
            message: 'Houve um erro ao receber o código',
            color: 'red',
            position: 'top-right',
          });
        });
    },
    receberCodigo() {
      this.loadingReceberCodigo = true;

      const data = {
        celular: this.registro.celular,
      };

      this.$store.commit('registrar', {
        ...this.registrar,
        errors: {},
      });

      axios
        .post('/users/gerar-codigo-celular', data, {
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
          },
        })
        .then(res => {
          this.loadingVerificarCodigo = false;
          this.loadingReceberCodigo = false;

          // Envio falhou mas o código existe: o campo abre e o suporte o repassa.
          const envioFalhou = res.data.envio_falhou && res.data.uuid;

          if (!res.data.success && !envioFalhou) {
            this.$q.notify({
              message: res.data.message,
              color: 'orange',
              position: 'top-right',
            });

            this.$store.commit('registrar', {
              ...this.registrar,
              errors: res.data.errors || {},
            });
            return;
          }

          // O aviso de falha não fecha sozinho: sai quando deixa de valer.
          this.fecharAvisoDeEnvio();

          if (envioFalhou) {
            this.fecharAvisoEnvio = this.$q.notify({
              message: res.data.message,
              color: 'orange',
              position: 'top-right',
              timeout: 0,
              actions: [{ label: 'Fechar', color: 'white' }],
            });
          }

          this.recebeuPrimeiroCodigo = true;

          this.$store.dispatch('registro', {
            ...this.registro,
            uuid: res.data.uuid,
          });

          this.tempoProximoCodigo = 60;
          this.iniciarContadorTempoProximoCodigo();
        })
        .catch(() => {
          this.loadingVerificarCodigo = false;
          this.loadingReceberCodigo = false;

          this.$q.notify({
            message: 'Houve um erro ao receber o código',
            color: 'red',
            position: 'top-right',
          });
        });
    },
    iniciarContadorTempoProximoCodigo() {
      setTimeout(() => {
        if (this.tempoProximoCodigo > 0) {
          this.tempoProximoCodigo--;
          this.iniciarContadorTempoProximoCodigo();
        }
      }, 1000);
    },
    fecharAvisoDeEnvio() {
      if (this.fecharAvisoEnvio) {
        this.fecharAvisoEnvio();
        this.fecharAvisoEnvio = null;
      }
    },
    resetCelularValido() {
      this.fecharAvisoDeEnvio();
      this.codigo = null;
      this.ultimoCodigo = null;
      this.codigoValido = false;
    },
  },
  mounted() {
    bus.on('celularDiferenteRegistro', () => this.resetCelularValido());
  },
  unmounted() {
    this.fecharAvisoDeEnvio();
    bus.off('celularDiferenteRegistro');
  },
};
</script>

<style lang="stylus" scoped>
// vue3-youtube sizes the player iframe from its width/height props and ignores the style on
// the component; the iframe follows the wrapper, as on Vue 2 (560x315 at most)
.video-youtube :deep(iframe)
  width 100% !important
  max-width 560px
.registration-container
  width 100%
  max-width 700px

.registration-card, .success-card
  border-radius 16px
  box-shadow 0 10px 40px rgba(0, 0, 0, 0.1)

.custom-stepper
  box-shadow none

  >>> .q-stepper__header
    border-radius 0

  >>> .q-stepper__tab
    padding 16px 24px

    &--active
      color #1976d2

    &--done
      color #21ba45

  >>> .q-stepper__dot
    width 32px
    height 32px
    font-size 16px

  >>> .q-stepper__content
    padding 24px 0

.success-card
  max-width 700px
  margin 0 auto

.q-btn
  transition all 0.3s ease

  &:hover
    transform translateY(-2px)
    box-shadow 0 4px 12px rgba(0, 0, 0, 0.15)
</style>